import { SIGN_IN_MODAL } from '~/constants/dynamicModals';

// @DEPRECATED
export const MIMETypes = Object.freeze({
  AUDIO: 'audio/*,audio/basic,audio/mpeg,audio/x-aiff,audio/x-mpegurl,audio/x-wav*',
});

export const COOKIE_NAME_SOCIAL_SIGNUP = 'trackSocialSignup';
export const COOKIE_NAME_REDIRECT_SIGNUP = 'signupRedirect';

export const commonModalNames = Object.freeze({
  SIGN_IN: SIGN_IN_MODAL,
  SIGN_UP: 'sign-up',
});

export const WAR_ROOM_COMMISSION_TOOLTIP = 'war-room-commission-tooltip';
export const NEW_SUPER_INVITES_TOOLTIP = 'new_super_invites_tooltip';
export const WAR_ROOM_MEGATHREADS_TOOLTIP = 'war-room-megathreads-tooltip';
export const WAR_ROOM_DEALS_TOOLTIP = 'war-room-deals-tooltip';
export const PORTFOLIO_HEADER_MENU_TOOLTIP = 'portfolio_header_menu_tooltip';
export const TOP_FLEX_VACANCIES_TOOLTIP = 'top_flex_vacancies_tooltip';

// disable for now
// first element will be shown last
export const ONBOARDING_TOOLTIPS = [
  PORTFOLIO_HEADER_MENU_TOOLTIP,
  // WAR_ROOM_DEALS_TOOLTIP,
  // WAR_ROOM_MEGATHREADS_TOOLTIP,
  // NEW_SUPER_INVITES_TOOLTIP,
  // WAR_ROOM_COMMISSION_TOOLTIP,
];

export const loadingState = Object.freeze({
  IDLE: 'idle',
  SUBMITTING: 'submitting',
  SUCCESS: 'success',
  ERROR: 'error',
});
